export default "__VITE_ASSET__a03bf5f2__"